import Grid from "../../../../components/Grid";
import { useLayout } from "../../../../provider/LayoutProvider";

interface ComponentProps {

}

const Component = (props: ComponentProps) => {
  const { layout, setLayout } = useLayout();

  return (
    <Grid.ContainerFluid>
      <Grid.Row>
        <Grid.Col>
          Community
        </Grid.Col>
      </Grid.Row>
    </Grid.ContainerFluid>
  );
};

export default Component